import { colors } from "@theme/theming";
import styled from "styled-components";

export const IconsContainer = styled.span`
	display: flex;
	flex-direction: row;
	justify-content: center;
	color: ${colors.white};
`;
